// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "code/chunk-" + {"47":"subapps/settings-e96e9bea","64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat"}[chunkId] + "." + {"47":"12435e795f0be7b5c418","64":"1596d4009eeeaa245988","266":"24a0e4175d577a320300","757":"29c2ce12d7a5c33755ce"}[chunkId] + ".css";
};